import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface BackButtonProps {
  to?: string
  isRTL?: boolean
}

const BackButton: React.FC<BackButtonProps> = ({ to = '/login', isRTL = false }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  
  return (
    <button
      className={`h-[36px] pt-15 pl-15 pr-15   w-[78px] top-6    absolute bg-white rounded-xl inline-flex justify-center items-center gap-1 overflow-hidden ${
        isRTL ? 'right-[17px]' : 'left-[17px]'
      }`}
      onClick={() => navigate(to)}
    >
      <div className={`text-right justify-start text-black text-sm font-medium font-['IBM Plex Sans Arabic'] leading-5 ${
        isRTL ? 'order-2' : 'order-1'
      }`}>
        {t('common.back')}
      </div>
      
      <div className={`size-5  flex items-center justify-center ${isRTL ? 'order-1' : 'order-2'}`}>
        <svg 
          className={`w-1.5 h-2.5 ${isRTL ? 'rotate-180' : ''}`} 
          fill="none" 
          viewBox="0 0 6 10"
        >
          <path 
            d="M5 1L1 5L5 9" 
            stroke="#18181b" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </button>
  )
}

export default BackButton